const mixin = {
  computed: {
    hasOrganizationsModule() {
      return !!this.$store.getters.hasApiModuleOrganizations;
    },
  },
};

export default mixin;



// WEBPACK FOOTER //
// ./src/mixins/organizationsModule.js